import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';
import type {
  AuthSecret,
  WebhookTriggerFromApi,
  WebhookTriggerStep,
} from './types';
import {
  type AddErrorMessage,
  type MessageDictionary,
} from 'pages/AutomationEngine/messageDictionary';
import { AUTH_TYPES } from './constants';
import { checkDeleted } from 'pages/AutomationEngine/helpers';

const forApi = (orgDetails: WebhookTriggerStep): WebhookTriggerFromApi => {
  const {
    name,
    httpMethod,
    contentType,
    samplePostBody,
    extractors,
    extractRawBodyContent,
    extractUrlQueryString,
    authType,
    headers,
    secret,
  } = orgDetails;
  return {
    name,
    httpMethod,
    contentType,
    samplePostBody,
    extractors: extractors.map(({ id, isNew, ...extractor }) => extractor),
    extractRawBodyContent,
    extractUrlQueryString,
    authType,
    headers,
    secret,
  };
};

const forFlow = (
  trigger: WebhookTriggerFromApi,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary
) => {
  const {
    name,
    httpMethod,
    contentType,
    samplePostBody,
    extractors,
    extractRawBodyContent,
    extractUrlQueryString,
    authType,
    headers,
    secret,
  } = trigger;

  if (authType === AUTH_TYPES.BASIC_AUTH) {
    checkDeleted(
      messageDictionary,
      addErrorMessage,
      secret,
      ({ apiName, description }: AuthSecret) => description || apiName
    );
  }
  return {
    type: AUTOMATION_STEPS.webhook.type,
    name,
    httpMethod,
    contentType,
    samplePostBody,
    extractors,
    extractRawBodyContent,
    extractUrlQueryString,
    authType,
    headers,
    secret,
  };
};

export const webhookDTO = {
  forApi,
  forFlow,
};
